module.exports = __webpack_public_path__ + "static/img/6.c390bdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/6.png
// module id = lvZ8
// module chunks = 0